<template>
  <Header />
  
  <!-- 홈페이지인 경우: main 태그에 hero-grid 포함 -->
  <main v-if="isHomePage">
    <!-- 현재 사용중: 4단 고정 그리드 배너 (홈에서만 표시) -->
    <section id="main-banner" aria-label="주요 서비스">
      <div class="hero-grid">
        <div class="hero-card">
          <h2>SO World STOCK LOAN<br>대출상품안내</h2>
          <router-link to="/info/so_c1010" class="hero-btn">추가대출 &gt;</router-link>
        </div>
        <div class="hero-card">
          <h2>보유주식의<br>대출가능여부 확인</h2>
          <router-link to="/loan/so_c2010" class="hero-btn">대출가능종목조회 &gt;</router-link>
        </div>
        <div class="hero-card">
          <h2>주식기준<br>대출가능금액 확인</h2>
          <router-link to="/loan/so_c2005" class="hero-btn">대출가능금액조회 &gt;</router-link>
        </div>
        <div class="hero-card">
          <h2>거래내역에 따른<br>약관 약정서 보기</h2>
          <router-link to="/support/so_c5020" class="hero-btn">약관약정서 보기 &gt;</router-link>
        </div>
      </div>
    </section>
  </main>
  
  <!-- 홈이 아닌 페이지: 일반 main 태그 -->
  <main v-else>
    <router-view />
  </main>
  
  <section v-if="isHomePage" id="customer-info">
    <div class="customer-info-container">
      <!-- 좌측: 보이스피싱 슬라이드 (작은 박스) -->
      <div class="warning-slider-wrapper">
        <div class="warning-slider">
          <div class="warning-slides">
            <div class="warning-slide" :class="{ active: currentWarningSlide === 0 }">
              <h3>개인정보 보호<br>안내</h3>
              <p>개인정보는 절대 공유하지 마세요.</p>
              <p>안전한 금융거래를 위해!</p>
            </div>
            <div class="warning-slide" :class="{ active: currentWarningSlide === 1 }">
              <h3>보이스피싱<br>피해 방지 주의 안내</h3>
              <p>보이스피싱 예방이 최선입니다.</p>
              <p>긴급사기 피해 주의!</p>
            </div>
            <div class="warning-slide" :class="{ active: currentWarningSlide === 2 }">
              <h3>대출 사칭<br>보이스피싱 주의</h3>
              <p>정식 업체만 이용하세요.</p>
              <p>의심되면 즉시 신고하세요!</p>
            </div>
          </div>
          <div class="warning-dots">
            <span 
              v-for="(slide, index) in 3" 
              :key="index"
              class="warning-dot" 
              :class="{ active: currentWarningSlide === index }"
              @click="currentWarningSlide = index"
            ></span>
          </div>
        </div>
      </div>
      
      <!-- 중앙: 전화번호 -->
      <div class="phone-info-wrapper">
        <div class="phone-info">
          <p class="contact-label">전국 어디서나 고객상담 센터</p>
          <p class="contact-phone">1833-8996</p>
          <p class="contact-hours">(이용가능시간 : 평일 09:00 ~ 18:00)</p>
        </div>
      </div>
      
      <!-- 우측: 버튼들 -->
      <div class="buttons-wrapper">
        <div class="contact-buttons">
          <router-link to="/support/so_c5010" class="contact-btn">FAQ →</router-link>
          <router-link to="/support/so_c5020" class="contact-btn">약관·약정서 보기 →</router-link>
        </div>
      </div>
    </div>
  </section>
  
  <Footer />

  <!-- AI 어시스턴트 플로팅 위젯 — 모든 클라이언트 화면 우하단 고정 -->
  <AiChatbotWidget />
</template>

<script>
import Header from '@/include/Header.vue'
import Footer from '@/include/Footer.vue'
import AiChatbotWidget from '@/include/AiChatbotWidget.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    AiChatbotWidget
  },
  data() {
    return {
      currentWarningSlide: 0,
      warningSlideTimer: null
    }
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/'
    }
  },
  mounted() {
    this.startWarningSlider()
  },
  beforeUnmount() {
    this.stopWarningSlider()
  },
  methods: {
    startWarningSlider() {
      this.stopWarningSlider()
      this.warningSlideTimer = setInterval(() => {
        this.currentWarningSlide = (this.currentWarningSlide + 1) % 3
      }, 3000)
    },
    stopWarningSlider() {
      if (this.warningSlideTimer) {
        clearInterval(this.warningSlideTimer)
        this.warningSlideTimer = null
      }
    }
  }
}
</script>

<style src="@/assets/styles/style.css"></style>
<style src="@/assets/styles/font-score-dream.css"></style>
